 
export const getCurrentIndexTabFormByTab = (tab: string) => (state: any) =>
  state.tabs[tab]?.index === undefined ? 0 : state.tabs[tab].index;

export const getCurrentIndexTabFormByTabVertical =
   
  (tab: string) => (state: any) => {
    const tabIndex = state.tabsVertical[tab]?.index;
    return tabIndex !== undefined ? tabIndex : 0;
  };

 
export const getNewActionTabsState = (state: any) => {
  return state.actionTabs.path;
};
